import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { CreditReviewStore } from '../stores/creditReviewStore';
import { BackgroundItemStore } from '../stores/backgroundItemStore';

export const useCreditReviewStore = () =>
  useContext<{
    creditReviewStore: CreditReviewStore;
    creditItemStore: BackgroundItemStore;
  }>(StoreContext);